import { render, staticRenderFns } from "./AdditionalRewards.vue?vue&type=template&id=cba79f78&scoped=true"
import script from "./AdditionalRewards.vue?vue&type=script&lang=js"
export * from "./AdditionalRewards.vue?vue&type=script&lang=js"
import style0 from "./AdditionalRewards.vue?vue&type=style&index=0&id=cba79f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba79f78",
  null
  
)

export default component.exports